import * as SolanaWeb3 from "@solana/web3.js"
import { Resolution } from "@unstoppabledomains/resolution"
import { utils } from "ethers"

export default {
  solana: async (address) => {
    try {
      console.log(address);
      const pubKey = new SolanaWeb3.PublicKey(address);
      if (pubKey) return { status: true };
      // Check if the address is on the curve
      // const isOnCurve = SolanaWeb3.PublicKey.isOnCurve(pubKey.toBytes());
      // if (isOnCurve) {
      //   return { status: true };
      // } else {
      //   return { status: false, message: "Invalid address" };
      // }
    } catch (err) {
      console.error(err);
      return { status: false, message: "Invalid address" };
    }
  },
  ethereum: async (address) => {
    const resolution = new Resolution();
    if (utils.isAddress(address)) return { status: true };
    else {
      try {
        const resp = await resolution.addr(address, "ETH");
        return { status: true, data: resp };
      } catch (err) {
        console.log(err);
        return { status: false };
      }
    }
  },
  flow: (address) => {
    return { status: true };
  },
  near: (address) => {
    return { status: true };
  },
  ordinals: (address) => {
    return { status: true };
  },
  aptos: (address) => {
    if (address.length !== 66) {
      return { status: false };
    }
  
    // Check for format (hexadecimal string starting with "0x")
    if (!/^0x[0-9a-fA-F]+$/.test(address)) {
      return { status: false };
    }
  
    // Address format is valid
    return { status: true };
  },
  ton: (address) => {
    // Validate Bounceable and Non-bounceable formats
    const bounceableRegex = /^[A-Za-z0-9_-]{48}$/; // Example regex for Bounceable
    const nonBounceableRegex = /^[A-Za-z0-9_-]{48}$/; // Example regex for Non-bounceable
    const rawHexRegex = /^[0-9a-fA-F]{64}$/; // Regex for RAW (HEX)

    if (bounceableRegex.test(address) || nonBounceableRegex.test(address) || rawHexRegex.test(address)) {
      return { status: true };
    }

    return { status: false };
  },
  sui: (address) => {
    // Check for Sui address length (Sui addresses can be 66 characters with "0x" + 64 hexadecimal characters)
    if (address.length !== 66) {
        return { status: false };
    }

    // Check for format (hexadecimal string starting with "0x")
    if (!/^0x[0-9a-fA-F]{64}$/.test(address)) {
        return { status: false };
    }

    // Address format is valid
    return { status: true };
  },
  hyperliquid: address => {
    // Check for Hyperliquid address length (42 characters: "0x" + 40 hexadecimal characters)
    if (address.length !== 42) {
      return { status: false };
    }

    // Check for format (hexadecimal string starting with "0x")
    if (!/^0x[0-9a-fA-F]{40}$/.test(address)) {
      return { status: false };
    }

    // Address format is valid
    return { status: true };
  }
};
